import axiosInstance from './axiosInstance';
import { IClipListResponse } from '../interfaces/Clip/IClipListResponse.ts';
import { IClipAssignResponse } from '../interfaces/Clip/IClipAssignResponse.ts';

class ClipService {
  private static instance: ClipService;
  private constructor() {}

  public static getInstance(): ClipService {
    if (!ClipService.instance) {
      ClipService.instance = new ClipService();
    }
    return ClipService.instance;
  }

  public async getClips(params?: {
    page?: number;
    per_page?: number;
    query?: string;
    ignore_case?: boolean;
    orderBy?: string;
    sortOrder?: 'asc' | 'desc' | null;
    carehome_id?: string;
    gateway_id?: string;
    is_active?: boolean;
    with_gateway?: boolean;
    with_resident?: boolean;
    unassigned?: boolean;
  }): Promise<IClipListResponse> {
    try {
      const filteredParams = Object.fromEntries(
        Object.entries(params || {}).filter(
          ([, value]) => value !== undefined && value !== null && value !== ''
        )
      );

      const response = await axiosInstance.get<IClipListResponse>('/clips', {
        params: filteredParams,
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch clips');
    }
  }

  public async assignClipToGateway(
    clipId: string,
    gatewayId: string
  ): Promise<IClipAssignResponse> {
    try {
      const response = await axiosInstance.post<IClipAssignResponse>(
        `/clips/${clipId}/gateway/${gatewayId}`
      );
      return response.data;
    } catch (error) {
      throw new Error('Failed to assign clip to gateway');
    }
  }

  public async deAssignClipFromGateway(clipId: string): Promise<void> {
    try {
      await axiosInstance.delete(`/clips/${clipId}/gateway`);
    } catch (error) {
      throw new Error('Failed to deassign clip from gateway');
    }
  }

  public async disposeClip(clipId: string): Promise<void> {
    try {
      await axiosInstance.put(`/clips/${clipId}/disposed`);
    } catch (error) {
      throw new Error('Failed to dispose clip');
    }
  }
}

export default ClipService.getInstance();
